import { useIntl } from 'react-intl';
import classnames from 'classnames';

import { Checkbox } from 'ui-components/components/checkbox';
import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';

import type { CardType } from '../../types';
import { CARD_REGISTRY } from '../../constants/card-registry';
import { useCardData } from '../../hooks/use-card-data';
import style from './edit-cards-modal.module.less';

const LOADING_PLACEHOLDER = '—';

type CardOptionProps = {
  cardType: CardType;
  isSelected: boolean;
  isDisabled: boolean;
  onToggle: () => void;
};

export const CardOption = ({ cardType, isSelected, isDisabled, onToggle }: CardOptionProps) => {
  const intl = useIntl();
  const cardData = useCardData(cardType);
  const config = CARD_REGISTRY[cardType];
  const { labelMessage, viewLinkMessage } = config;

  const label = intl.formatMessage(labelMessage);
  const viewLinkLabel = intl.formatMessage(viewLinkMessage);
  const displayValue = cardData.value ?? LOADING_PLACEHOLDER;

  return (
    <div
      className={classnames(style['card-option'], {
        [style['card-option-selected']]: isSelected,
        [style['card-option-disabled']]: isDisabled,
      })}
      onClick={!isDisabled ? onToggle : undefined}
    >
      <div className={style['card-option-checkbox']}>
        <Checkbox checked={isSelected} disabled={isDisabled} label={label} onChange={onToggle} />
      </div>
      <FlexColumn gap={Gap.Space4}>
        <Text className={style['card-option-label']} textType={TextType.Paragraph} value={label} />
        <div className={style['card-option-value']}>{displayValue}</div>
        <Text className={style['card-option-link']} textType={TextType.Paragraph} value={viewLinkLabel} />
      </FlexColumn>
    </div>
  );
};
